// Module
var code = "<div class=\"migrated\"> <div class=\"contextual-menu hidden-print\"> <wt-contextual-control fields=\"vm.properties\" form-controller=\"vm.formController\" has-property-types=\"true\" item=\"vm.model\" modern-design=\"true\" on-cancel=\"vm.cancel()\" save=\"vm.save()\" set-autocomplete=\"off\"> </wt-contextual-control> </div> </div>";
// Exports
module.exports = code;